import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import OvernightPopupCard from "./OvernightPopupCard";
import { useCopyOverride, usePromoActive, isPromoPreview, COPY_DEFAULTS } from "@/lib/copyOverrides";
import { hasSeenPopupToday, markPopupSeenToday } from "@/lib/popupSession";
import { sendPromoEvent } from "@/lib/promoEvents";

const SUPPRESSED_PREFIXES = [
  "/control",
  "/admin",
  "/images5",
  "/pay",
  "/thankyou",
  "/book",
  "/checkout",
  "/cart",
  "/waivers",
  "/shared-waivers",
];

const OvernightPopupModal = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const delayRaw = useCopyOverride("popup.delayMs", COPY_DEFAULTS["popup.delayMs"]);
  const href = useCopyOverride("popup.href", COPY_DEFAULTS["popup.href"]);
  const active = usePromoActive("popup");
  const preview = isPromoPreview("popup");

  const suppress = SUPPRESSED_PREFIXES.some((p) => location.pathname.startsWith(p));

  useEffect(() => {
    if (suppress) return;
    if (preview) {
      const t = window.setTimeout(() => setOpen(true), 500);
      return () => window.clearTimeout(t);
    }
    if (!active) return;
    if (hasSeenPopupToday()) return;
    const delay = Math.max(1000, Number(delayRaw) || 10000);
    const t = window.setTimeout(() => {
      if (!hasSeenPopupToday()) {
        markPopupSeenToday();
        setOpen(true);
      }
    }, delay);
    return () => window.clearTimeout(t);
  }, [delayRaw, suppress, active, preview, location.pathname]);

  useEffect(() => {
    if (!active && !preview) setOpen(false);
  }, [active, preview]);

  useEffect(() => {
    if (open) sendPromoEvent("popup", "view");
  }, [open]);

  const handleCta = () => {
    sendPromoEvent("popup", "click");
    setOpen(false);
    if (/^https?:\/\//i.test(href)) {
      window.open(href, "_blank", "noopener,noreferrer");
    } else {
      navigate(href);
    }
  };

  if (suppress || (!active && !preview)) return null;



  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-xl p-0 overflow-hidden bg-transparent border-0 shadow-none">
        <VisuallyHidden>
          <DialogTitle>Overnight stays on Son's Island</DialogTitle>
        </VisuallyHidden>
        <OvernightPopupCard onCta={handleCta} />
      </DialogContent>
    </Dialog>
  );
};

export default OvernightPopupModal;